module.exports = __webpack_public_path__ + "static/media/11.d41626fd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/11.svg
// module id = 138
// module chunks = 0